import script from "./WxNewDramaDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./WxNewDramaDrawer.vue?vue&type=script&setup=true&lang=js"

import "./WxNewDramaDrawer.vue?vue&type=style&index=0&id=003faf18&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003faf18"]])

export default __exports__